import { render, staticRenderFns } from "./ExternalePrenotazioniListPresaInCaricoComponent.vue?vue&type=template&id=faaac2a8&scoped=true"
import script from "./ExternalePrenotazioniListPresaInCaricoComponent.vue?vue&type=script&lang=js"
export * from "./ExternalePrenotazioniListPresaInCaricoComponent.vue?vue&type=script&lang=js"
import style0 from "./ExternalePrenotazioniListPresaInCaricoComponent.vue?vue&type=style&index=0&id=faaac2a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaac2a8",
  null
  
)

export default component.exports